import Location from "@/models/Location";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";

const LocationModelService = {
  // this is a nice way to limit locations for vendors/runners - but its just for UX, not security per se (see users can access it yet)
  currentUserLocations() {
    let getUserLocations = firebase
      .functions()
      .httpsCallable("getUserLocations");

    return getUserLocations();
  },

  acceptingOrdersQuery() {
    return firebase
      .firestore()
      .collection("locations")
      .withConverter(Location.firebaseConverter)
      .orderBy("name")
      .where("acceptingOrders", "==", true);
  }
};

export default LocationModelService;
